/* globals Class */
var jQuery = require('jquery');
var _ = require('lodash');

var TextElement = require('./text_element');
var InlineTextStyleAPI = require('ub/ui/inline-text/APIs/inline-text-style-api').default;
var DynamicTextAPI = require('ub/ui/inline-text/APIs/dynamic-text-api');
var FroalaOptions = require('ub/froala-option-config').default;
var DynamicTextModal = require('ub/ui/dynamic_text_modal');
var selectionHighlightImitator = require('ub/ui/inline-text/utils/selection-highlight-imitator').default;
var mouseDownObserver = require('ub/control/mouse-down-selection').default;
var inlineTextStateSubjects = require('ub/ui/inline-text/states/inline-text-state-subjects');
var textCleaner = require('ub/ui/inline-text/text-cleaner').default;
var imgCleaner = require('ub/ui/inline-text/img-cleaner').default;
var backgroundStyleCleaner = require('ub/ui/inline-text/img-cleaner').default;
var recordTextStyle = require('ub/control/inherit-text-style').recordTextStyle;

// Line Height:
// All <span> tags inside text elements previously had a `line-height : 0` property,
// specified in page-defaults.css. Our previous text editor: CKEditor used to add lplh-* classes
// to <p> tags, which overrided that with a real line-height value. So, when an element's
// font size is changed with Froala, we do two things (in _handleFroalaCommand):
// 1) We add a model flag `content.editedInline`, which allows us to add a class to the
//    text element in the DOM (in both edit and publish) that overrides to line-height to
//    1. This value means that by default the line-height will match the font size,
//    without the need for us to use classes or inline line-height styles.
// 2) We remove the legacy lplh-* class from the selection's <p> tag. Since line-height
//    changes with Froala will be done with inline styles, we do this so that the lplh-*
//    styles don't conflict with these.

var TextElementInline = Class.create(TextElement, {
  initView: function($super) {
    $super();

    this.froalaEditor = null;
    this.inEditMode = false;

    this.sourceModeObs = inlineTextStateSubjects
      .panelEventsSubject
      .filter(function(ev) {
        return ev.type === 'toggleSourceMode';
      })
      .subscribe(this._cleanTextContent.bind(this));

    this.$froalaContainer = jQuery('<div />')
      .addClass('text-content')

      .on('dblclick', function(ev) {
        if (!this.inEditMode) {
          ev.stopPropagation(); // TODO: remove
          this.enterEditMode(ev);
        }
      }.bind(this))

      .on('click mouseover mouseout mousedown keyup keypress keydown', function(ev) {
        // In edit mode, prevent events from bubbling up to the text element itself.
        if (this.inEditMode) {
          ev.stopPropagation();
        }
      }.bind(this))

      .html(this.getContent());

    this.$froalaContainer
      .on('froalaEditor.initialized', this._handleFroalaInitialized.bind(this))
      .on('froalaEditor.contentChanged', this._updateModelFromFroala.bind(this))
      .on('froalaEditor.commands.after', this._handleFroalaCommand.bind(this))
      .on('froalaEditor.keydown', this._handleKeyDownEvent.bind(this))
      .on('froalaEditor.keyup froalaEditor.mouseup', this._handleFroalaKeyAndMouseUp.bind(this))
      .on('froalaEditor.paste.after', this._cleanTextContent.bind(this))
      .froalaEditor(FroalaOptions);

    jQuery(this.view.e).html(this.$froalaContainer);
  },

  _isSaveShortkey: function(e) {
     return (e.metaKey || (e.ctrlKey && !e.altKey)) && e.keyCode === 83; // Ctrl-S or Cmd-S
  },

  _addSelectionHighlightListeners: function() {
    this.froalaEditorContents.addEventListener('blur', selectionHighlightImitator.imitateSelection.bind(this));
    this.froalaEditorContents.addEventListener('focus', selectionHighlightImitator.removeAllSelections.bind(this));
  },

  _upgradeDtrTag: function() {
    // See PB-2167, this is to ensure backward compatability
    // and that tags created with our previous text editor will work with the new behaviours
    // designed for inlin-text editor. This will need to be here even after inline
    // text become the default text editor
    this.$froalaContainer.find('ub\\:dynamic')
      .removeAttr('contenteditable')
      .addClass('text-editor-dynamic-tag');
  },

  _openDynamicTextDialog: function(ev) {
    if ( ! this.inEditMode) { return; }

    var dynamicTextDialog = new DynamicTextModal({});
    var clickTarget = jQuery(ev.target);
    var targetDefaultText = clickTarget.text().trim();
    var targetAttributes = {
      method: clickTarget.attr('method'),
      parameter: clickTarget.attr('parameter')
    };

    dynamicTextDialog.open(
      targetDefaultText,
      targetAttributes,
      function submissionCallback(defaultText, attributes) {
        DynamicTextAPI.updateDynamicText(clickTarget, defaultText, attributes);
      }
    );
  },

  _configureDtr: function() {
    this._upgradeDtrTag();

    this.$froalaContainer.on('dblclick', '.text-editor-dynamic-tag', this._openDynamicTextDialog.bind(this));

    this.$froalaContainer.on('mouseout', '.text-editor-dynamic-tag', function(event) {
      if (this.inEditMode) {
        DynamicTextAPI.hideRemoveDtrButton(event);
      }
    }.bind(this));

    this.$froalaContainer.on('mouseover', '.text-editor-dynamic-tag', function(event) {
      if (this.inEditMode) {
        DynamicTextAPI.repositionRemoveDtrButton(event);
      }
    }.bind(this));
  },

  _cleanTextContent: function() {
    if (textCleaner.hasFontTags(this.froalaEditorContents)) {
      var newContent = textCleaner.replaceFontTags(this.froalaEditorContents);
      this.froalaEditor.html.set(newContent);
    }
  },

  _handleFroalaInitialized: function(event, froalaEditor) {
    this.froalaEditor = froalaEditor;
    this.froalaEditorContents = froalaEditor.el;

    this.inlineTextStyleAPI = new InlineTextStyleAPI(froalaEditor);

    froalaEditor.edit.off();

    this._addSelectionHighlightListeners();

    this._configureDtr();
  },

  _handleKeyDownEvent: function(ev, editor, jQueryEvent) {
    if (this._isSaveShortkey(jQueryEvent)) {
      jQueryEvent.preventDefault(); // Prevent browser from trying to save page on ctrl/cmd-s
      this._updateModelFromFroala();
      window.editor.save();
    }

    this.updateHeight();
  },

  _handleFroalaKeyAndMouseUp: function() {
    this.updateHeight();

    inlineTextStateSubjects
      .panelEventsSubject
      .onNext({type: 'updateCurrentTextStyles'});

    this.setText(this.froalaEditor.html.get(), this.page.undoManager);
  },

  enterEditMode: function(clickEvent) {
    this.inEditMode = true;

    window.editor.triPane.showPane('right');

    this.getViewDOMElement().addClassName('in-edit-mode');

    this.froalaEditor.edit.on();

    if (this.froalaEditor.$el.text() === TextElementInline.defaultText) {
      this.froalaEditor.commands.selectAll();
    } else if (clickEvent) {
      this._setCursorToEventMousePosition(clickEvent);
    }

    this._cleanTextContent();

    DynamicTextAPI.setEditor(this.froalaEditor);

    inlineTextStateSubjects.textEvents.onNext({ type: 'enterEditMode' });
  },

  _updateModelFromFroala: function() {
    this.froalaEditor.html.cleanEmptyTags();
    this.setText(this.froalaEditor.html.get(), this.page.undoManager);
  },

  _handleFroalaCommand: function(ev, froalaEditor, command /*, value */) {
    if (command === 'fontSize') {
      // See line-height comment at top of file
      this.model.set('content.editedInline', true, null);
      jQuery(this.view.e).addClass('inline');
    }
  },

  _setSelection: function(froalaEditor, clickEvent) {
    // We must use froala selection here to make froala work properly with firefox
    froalaEditor.markers.insertAtPoint(clickEvent);

    // These two lines fix a bug where the marker doesn't get placed on first double-click
    var $marker = froalaEditor.$el.find('.fr-marker');
    $marker.replaceWith(window.jQuery.FE.MARKERS);

    this.inlineTextStyleAPI.restoreSelection();
  },

  _setCursorToEventMousePosition: function(clickEvent) {
    this._setSelection(this.froalaEditor, clickEvent);

    // The second arg is a boolean which force shows the editor
    // even if there is not selection in the WYSIWYG HTML editor.
    this.froalaEditor.toolbar.showInline(clickEvent, true);
  },

  _clearSelection: function() {
    if (window.getSelection) {
      window.getSelection().removeAllRanges();
    }
  },

  exitEditMode: function() {
    this._clearSelection();

    this.froalaEditor.edit.off();

    this.froalaEditor.html.set(backgroundStyleCleaner(this.froalaEditor.html.get()));
    this.froalaEditor.html.set(imgCleaner(this.froalaEditor.html.get()));

    if (this.inEditMode && this.froalaEditor.$el.text().trim() === '') {
      this.model.set(
        'content.text',
        TextElementInline.elementDefaults.content.text,
        this.page.undoManager
      );
    }

    this.sourceModeObs.dispose();

    DynamicTextAPI.setEditor(null);

    this.inEditMode = false;

    this.getViewDOMElement().removeClassName('in-edit-mode');

    recordTextStyle(this);
  },

  modelChanged: function($super, e) {
    var details = $super(e);

    if (details.accessor === 'content.text') {
      var newText = this.getContent(details.value);

      if (newText !== this.froalaEditor.html.get()) {
        this.froalaEditor.html.set(newText);
      }
    }
  },

  _saveStateOfTextSelection: function() {
    // Save the state of the current selected text on mousedown.
    // We do this because we need to save the state of the current selection before
    // the text editor loses focus. Since mousedown occurs before blur and focus
    // we can capture its state before the focus switches to a new target.
    this.mouseDownSubscription = mouseDownObserver.subject
      .filter(function() {
        return this.inlineTextStyleAPI.isFocused();
      }.bind(this))
      .subscribe(function(ev) {
        selectionHighlightImitator.setElementAndRange(
          this.$froalaContainer[0],
          ev.newSelection.getRangeAt(0)
        );

        inlineTextStateSubjects.panelEventsSubject.onNext({
          type: 'updateSelectedText',
          value: ev.newSelection.toString()
        });

        this.inlineTextStyleAPI.saveSelection();
      }.bind(this));
  },

  activate: function($super) {
    this._saveStateOfTextSelection();

    $super();
  },

  deactivate: function($super) {
    this.mouseDownSubscription.dispose();

    if (this.inEditMode) {
      inlineTextStateSubjects.textEvents.onNext({ type: 'exitEditMode' });
      this.exitEditMode();
    }

    $super();

    selectionHighlightImitator.removeAllSelections();
  }
});

TextElementInline.defaultText = TextElement.defaultText;
TextElementInline.elementDefaults = _.merge({}, TextElement.elementDefaults);

module.exports = TextElementInline;



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/modules/lp-text/text_element_inline.js
// module id = 1434
// module chunks = 0